import { render, staticRenderFns } from "./MessagesDrafts.vue?vue&type=template&id=66705537&"
import script from "./MessagesDrafts.vue?vue&type=script&lang=js&"
export * from "./MessagesDrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports